import React from "react";
import { FaChessQueen } from "react-icons/fa";
type Props = {
  pieceHere: Boolean;
  isBlack: boolean;
};

function Cell({ pieceHere, isBlack }: Props) {
  return (
    <div
      className="SudokuBlock"
      style={{
        background: isBlack ? "#ff0a6c" : "white",
        color: "black",
        position: "relative",
      }}
    >
      {pieceHere && (
        <FaChessQueen
          style={{
            width: "25px",
            height: "25px",
            position: "absolute",
            background: "transparent",
          }}
        />
      )}
    </div>
  );
}

export default Cell;
